import "./Store/useStore";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import "./style/sass/main.css";
import "./style/all.min.css";
import Home from "./Pages/Home";

import Posts from "./Pages/Auth/Posts";
import DimensionProperties from "./layout/DimensionProperties";

import AuthRoutes from "./RoutesPermissions/AuthRoutes";
import RefreshToken from "./api/RefreshToken";

import React, { Suspense } from "react";
import LoadingPage from "./Pages/LoadingPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import UpdateProfile from "./Pages/Auth/profile/UpdateProfile";
import { Analytics } from "@vercel/analytics/react";
import SignRoutes from "./RoutesPermissions/SignRoutes";
import QuestionsPage from "./Pages/Auth/QuestionsPage";
import { AuthProvider } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext";
import VerifyUser from "./components/Auth/VerifyUser";
function App() {
  const AboutUs = React.lazy(() => import("./Pages/AboutUs"));
  const PrivacyPolicy = React.lazy(() => import("./Pages/PrivacyPolicy"));
  const TermsAndConditions = React.lazy(() => import("./Pages/Auth/TermsAndConditions"));
  const ForgotPassword = React.lazy(() => import("./Pages/Auth/ForgotPassword"));
  const ResetPassword = React.lazy(() => import("./Pages/Auth/ResetPassword"));
  const VerifyUse = React.memo(VerifyUser);
  DimensionProperties();
  const queryClient = new QueryClient();
  return (
    <>
      <Analytics />

      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <UserProvider>
            <RefreshToken />
            <VerifyUse />

            <Router>
              <Suspense fallback={<LoadingPage />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route element={<SignRoutes />}>
                    <Route path="/register" element={<Register child={"ss"} />} />
                    <Route path="/login" element={<Login />} />
                  </Route>
                  <Route path="/password/reset" element={<ForgotPassword />} />
                  <Route path="/password/confirm" element={<ResetPassword />} />
                  <Route path="/about" element={<AboutUs />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsAndConditions />} />
                  <Route path="/query" element={<QuestionsPage />} />
                  <Route element={<AuthRoutes />}>
                    <Route path="/posts" element={<Posts />} />
                    <Route path="/settings/:token?" element={<UpdateProfile />} />
                  </Route>
                </Routes>
              </Suspense>
            </Router>
          </UserProvider>
        </AuthProvider>
      </QueryClientProvider>
    </>
  );
}
export default App;
